import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { RootState, store } from 'app/store/configure-store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<typeof store.dispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
